<script>
// import { mapState } from 'vuex';
import MineTitle from '../../components/mineTitle.vue';

export default {
    name: "enrolledCourses",
    data() {
        return {
            list: []
        };
    },
    computed: {
        // ...mapState(['coursesList']),
    },
    components: {
        MineTitle
    },
    mounted() {
        this.$store.dispatch('getCourses').then((result) => {
            if (result.code == 100) {
                this.list = result.data;
            }
            else if (result.code == 90) { 
                this.$router.replace({
                    path: '/login',
                    query: { redirect: this.$route.fullPath }
                })
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="enrolledCourses">
        <MineTitle name="Enrolled Courses" page="Mine / Enrolled Courses"/>
        <div class="layout_table table">
            <div class="thead">
                <div class="tr">
                    <div class="td image">Thumbnail</div>
                    <div class="td">Title</div>
                    <div class="td time">Enrolled at</div>
                </div>
            </div>
            <div class="tbody">
                <div class="tr" v-for="(item, index) in list" :key="index">
                    <div class="td image"><img :src="item.image" alt=""/></div>
                    <div class="td">{{ item.name }}</div>
                    <div class="td time">{{ item.time }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.table{
    .image{
        flex: none;
        width: 2.8rem;
        @media only screen and (max-width: 750px) {
            width: 1.7rem;
        }
    }
    .time{
        flex: none;
        width: 3rem;
        @media only screen and (max-width: 750px) {
            width: 2rem;
        }
    }
}
</style>